import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { ReactComponent as EditIcon } from "../assets/icons/edit.svg";
import { ReactComponent as ValidateIcon } from "../assets/icons/validation.svg";
import { isAuthenticated, isEditor } from "../services/utils";
import { getImage, getImageFromDirectory, sendImage } from "../services/api";
import "../stylesheets/image.scss";

// PROPS

type ImageProps = {
	id: string;
	directory?: string;
};

// COMPONENT

function Image({ id, directory }: ImageProps) {
	// STATES
	const [image, setImage] = useState<string>("");
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const fileInput = useRef<HTMLInputElement | null>(null);
	// IMAGE FETCHING
	useEffect(() => {
		const fetchImage = async () => {
			setIsLoading(true);
			try {
				let data;
				if (directory == null) {
					data = await getImage(id);
				} else {
					data = await getImageFromDirectory(id, directory);
				}
				const type = "jpg";
				setImage(`data:image/${type};base64,${data.image}`);
			} catch (error) {
				return;
			} finally {
				setIsLoading(false);
			}
		};

		fetchImage();
	}, [id]);
	// IMAGE SENDING
	const handleFileSelected = (e: ChangeEvent<HTMLInputElement>) => {
		if (e.currentTarget.files && e.currentTarget.files[0]) {
			const file = e.currentTarget.files[0];

			// LOCAL PREVIEW
			const previewUrl = URL.createObjectURL(file);
			setImage(previewUrl);

			// COULD REFETCH FROM BACKEND IF NEEDED
			sendImage(id, file)
				.then(() => {})
				.catch((err) => console.error("Error uploading image:", err));
		}
	};

	return (
		<div
			className="editable-image"
			style={{
				backgroundImage: image
					? `url("${image}")`
					: `url("/assets/placeholder.jpg")`,
			}}
		>
			{isEditor() && (
				<div>
					<button onClick={() => fileInput.current?.click()}>
						<EditIcon />
					</button>

					<input
						ref={fileInput}
						type="file"
						accept=".png, .jpeg, .jpg"
						style={{ display: "none" }}
						onChange={(e) => handleFileSelected(e)}
					/>
				</div>
			)}
		</div>
	);
}

export default Image;
